var OrderService = function (APIService, PermissionService, $q, ErrorService) {
    var self = this;



    /**
     * Gets all users for a specific context
     * @param filter {object}
     * @param userContext {Dashboard.Models.Permissions.RoleContext}
     * @returns {*|HTTPPromise}
     */
    self.getOrdersForContext = function(filter, userContext) {
        filter = filter || {};
        userContext = userContext || {};
        return APIService.Orders.getOrders(filter, userContext);
    };

    /**
     * Gets all order channels.
     * @returns {Array} Channel array.
     */
    self.getOrderChannels = function() {
        return APIService.Orders.getOrderChannels();
    };

    /**
     * Gets an order by its GUID.
     * @returns {Object} The order.
     */
    self.getOrder = function(orderGuid) {
        return APIService.Orders.getOrder(orderGuid);
    };

    self.refundOrder = function(request) {
        return APIService.Orders.refundOrder(request);
    };

    self.getOrderTerminals = function(orderId) {
        return APIService.Orders.fetchTerminals(orderId);
    };
};

angular.module('dashboard')
    .service('OrderService', ['APIService', 'PermissionService', '$q', 'ErrorService', OrderService]);
